import { useCallback } from 'react'
import { useCreateDocumentVersionSessionEvent } from '@/services/queries/document_sessions'
import { useUpdateDocumentVersionSessionEvent } from '@/services/queries/document_sessions'
import { useTechnicianPageStore } from './useTechnicianPageStore'

export const useCreateSessionEvent = () => {
  const { mutate: creatEvent } = useCreateDocumentVersionSessionEvent()
  const { mutate: updateEvent } = useUpdateDocumentVersionSessionEvent()

  const currentSessionId = useTechnicianPageStore(
    (state) => state.currentSessionId,
  )

  const lastSessionEventId = useTechnicianPageStore(
    (state) => state.lastSessionEventId,
  )

  const createSessionEvent = useCallback(
    ({
      documentPageId,
      buttonLabel,
      completeLastEvent = true,
      completedTimestamp,
      onSuccess,
    }: {
      documentPageId: string
      buttonLabel: string
      completeLastEvent?: boolean
      completedTimestamp?: string
      onSuccess?: () => void
    }) => {
      const shouldCompleteEvent =
        lastSessionEventId && completeLastEvent && !completedTimestamp

      if (currentSessionId) {
        creatEvent({
          documentPageId,
          documentVersionSessionId: currentSessionId,
          buttonLabel,
          completedTimestamp,
          onSuccess: () => {
            if (!shouldCompleteEvent && typeof onSuccess === 'function') {
              onSuccess()
            }
          },
        })

        if (shouldCompleteEvent) {
          updateEvent({
            documentVersionSessionEventId: lastSessionEventId,
            completedTimestamp: new Date().toISOString(),
            onSuccess: () => {
              if (typeof onSuccess === 'function') {
                onSuccess()
              }
            },
          })
        }
      }
    },
    [creatEvent, currentSessionId, lastSessionEventId, updateEvent],
  )

  return {
    createSessionEvent,
  }
}
